import { Phases_getInstance1dciif7svdqxc as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  Phases_getInstance39l8b4mzhgwzm as Phases_getInstance_0,
  HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer,
} from '../statement/HttpResponsePipeline.mjs';
import {
  platformResponseDefaultTransformers258gm9ywvn5cc as platformResponseDefaultTransformers,
  platformRequestDefaultTransformv8a3p2llr8mo as platformRequestDefaultTransform,
} from './DefaultTransform.web.mjs';
import {
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
  ReadChannelContentz1amb4hnpqp4 as ReadChannelContent,
  OutgoingContent3t2ohmyam9o76 as OutgoingContent,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Application_getInstance3vhi2qmce4cj0 as Application_getInstance,
  Text_getInstance2n0fbbag7eq4k as Text_getInstance,
  Companion_getInstance2mdqh2piyf0f8 as Companion_getInstance,
  MultiPart_getInstance5h1nld8q49pe as MultiPart_getInstance,
} from '../../../../../ktor-ktor-http/io/ktor/http/ContentTypes.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toLongkk4waq8msp1k as toLong,
  toInt2q8uldh7sc951 as toInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  Unit_instance3kz1zqli6gr1r as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  contentType2zzm38yxo3syt as contentType,
  contentLength2suzxu1lzutku as contentLength,
} from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import {
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
  canceldn4b3cdqcfny as cancel,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isByteArray4nnzfn1x4o3w as isByteArray,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { TextContent1rb6ftlpvl1d2 as TextContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/TextContent.mjs';
import {
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  getKClass3t8tygqu4lcxf as getKClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  copyTo2t9ovypu2ttur as copyTo,
  rethrowCloseCauseIfNeeded3ixo8wl4o3bz4 as rethrowCloseCauseIfNeeded,
  toByteArraylei52b7x53md as toByteArray,
  readRemainingh4lyqt5j6r85 as readRemaining,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import {
  cancel2ztysw4v4hav6 as cancel_0,
  cancel36mj9lv3a0whl as cancel_1,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CIOMultipartDataBase3o5u8w437tq5s as CIOMultipartDataBase } from '../../../../../ktor-ktor-http-cio/io/ktor/http/cio/CIOMultipartDataBase.mjs';
import { MultiPartData57syw40llxls as MultiPartData } from '../../../../../ktor-ktor-http/io/ktor/http/content/Multipart.mjs';
import { HttpStatusCode3o1wkms10pg4k as HttpStatusCode } from '../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import {
  get_job2zvlvce9o9a29 as get_job,
  Job13y4jkazwjho0 as Job,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  writer1eia5its2a1fh as writer,
  invokeOnCompletion1ziuxzoag0iwj as invokeOnCompletion,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { attachWriterJob2dr3tee7atoa9 as attachWriterJob } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelUtils.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from '../call/utils.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { Source1shr0ps16u4p4 as Source } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Source.mjs';
import { readText3frapgncbqrcg as readText } from '../../../../../ktor-ktor-io/io/ktor/utils/io/Deprecation.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultTransform_kt__20knxx();
  return LOGGER;
}
var LOGGER;
function defaultTransformers(_this__u8e3s4) {
  _init_properties_DefaultTransform_kt__20knxx();
  var tmp = Phases_getInstance().Render_1;
  _this__u8e3s4.requestPipeline_1.intercept_k21bv3_k$(tmp, defaultTransformers$slambda());
  var tmp_0 = Phases_getInstance_0().Parse_1;
  _this__u8e3s4.responsePipeline_1.intercept_k21bv3_k$(tmp_0, defaultTransformers$slambda_0(_this__u8e3s4));
  platformResponseDefaultTransformers(_this__u8e3s4);
}
var defaultTransformers$1$content$1Class;
function defaultTransformers$1$content$1() {
  if (defaultTransformers$1$content$1Class === VOID) {
    class $ extends ByteArrayContent() {
      constructor($contentType, $body, $box) {
        if ($box === VOID)
          $box = {};
        $box.$body_1 = $body;
        super($box);
        var tmp = this;
        tmp.contentType_1 = $contentType == null ? Application_getInstance().OctetStream_1 : $contentType;
        this.contentLength_1 = fromInt($body.length);
      }
      get_contentType_7git4a_k$() {
        return this.contentType_1;
      }
      get_contentLength_a5o8yy_k$() {
        return this.contentLength_1;
      }
      bytes_1k3k2z_k$() {
        return this.$body_1;
      }
    }
    initMetadataForClass($);
    defaultTransformers$1$content$1Class = $;
  }
  return defaultTransformers$1$content$1Class;
}
var defaultTransformers$1$content$2Class;
function defaultTransformers$1$content$2() {
  if (defaultTransformers$1$content$2Class === VOID) {
    class $ extends ReadChannelContent() {
      constructor($this_intercept, $contentType, $body, $box) {
        if ($box === VOID)
          $box = {};
        $box.$body_1 = $body;
        super($box);
        var tmp = this;
        var tmp0_safe_receiver = $this_intercept.context_1.headers_1.get_6bo4tg_k$('Content-Length');
        tmp.contentLength_1 = tmp0_safe_receiver == null ? null : toLong(tmp0_safe_receiver);
        var tmp_0 = this;
        tmp_0.contentType_1 = $contentType == null ? Application_getInstance().OctetStream_1 : $contentType;
      }
      get_contentLength_a5o8yy_k$() {
        return this.contentLength_1;
      }
      get_contentType_7git4a_k$() {
        return this.contentType_1;
      }
      readFrom_ecr4ww_k$() {
        return this.$body_1;
      }
    }
    initMetadataForClass($);
    defaultTransformers$1$content$2Class = $;
  }
  return defaultTransformers$1$content$2Class;
}
function defaultTransformers$slambda() {
  return constructCallableReference(($this$intercept, body, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if ($this$intercept.context_1.headers_1.get_6bo4tg_k$('Accept') == null) {
      $this$intercept.context_1.headers_1.append_rhug0a_k$('Accept', '*/*');
      tmp = Unit_instance;
    }
    var contentType_0 = contentType($this$intercept.context_1);
    var tmp0_subject = body;
    var tmp_0;
    if (typeof tmp0_subject === 'string') {
      tmp_0 = new (TextContent())(body, contentType_0 == null ? Text_getInstance().Plain_1 : contentType_0);
    } else {
      if (isByteArray(tmp0_subject)) {
        tmp_0 = new (defaultTransformers$1$content$1())(contentType_0, body);
      } else {
        if (isInterface(tmp0_subject, ByteReadChannel())) {
          tmp_0 = new (defaultTransformers$1$content$2())($this$intercept, contentType_0, body);
        } else {
          if (tmp0_subject instanceof OutgoingContent()) {
            tmp_0 = body;
          } else {
            tmp_0 = platformRequestDefaultTransform(contentType_0, $this$intercept.context_1, body);
          }
        }
      }
    }
    var content = tmp_0;
    var tmp_1;
    if (!((content == null ? null : content.get_contentType_7git4a_k$()) == null)) {
      $this$intercept.context_1.headers_1.remove_6241ba_k$('Content-Type');
      get_LOGGER().trace_fti9bv_k$('Transformed with default transformers request body for ' + $this$intercept.context_1.url_1.toString() + ' from ' + toString(getKClassFromExpression(body)));
      yield* $this$intercept.proceedWith_i5skhv_k$(content, $completion);
      tmp_1 = Unit_instance;
    }
    return Unit_instance;
  }), 2);
}
function defaultTransformers$slambda$slambda($body, $response) {
  return constructCallableReference(($this$writer, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    try {
      yield* copyTo($body, $this$writer.channel_1, 9223372036854775807n, $completion);
      rethrowCloseCauseIfNeeded($body);
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException()) {
        var cause = $p;
        cancel_1($response, cause);
        throw cause;
      } else {
        if ($p instanceof Error) {
          var cause_0 = $p;
          cancel_0($response, 'Receive failed', cause_0);
          throw cause_0;
        } else {
          throw $p;
        }
      }
    }
    return Unit_instance;
  }), 1);
}
function defaultTransformers$slambda_0($this_defaultTransformers) {
  return constructCallableReference(($this$intercept, _destruct__k2r9zo, $completion) => orPromise($completion, function *($completion) {
    var info = _destruct__k2r9zo.component1_7eebsc_k$();
    var body = _destruct__k2r9zo.component2_7eebsb_k$();
    if (!isInterface(body, ByteReadChannel()))
      return Unit_instance;
    var response = $this$intercept.context_1.get_response_xlk07e_k$();
    var tmp0_subject = info.type_1;
    var tmp;
    if (tmp0_subject.equals(getKClass(Unit()))) {
      cancel(body);
      tmp = yield* $this$intercept.proceedWith_i5skhv_k$(new (HttpResponseContainer())(info, Unit_instance), $completion);
    } else if (tmp0_subject.equals(PrimitiveClasses_getInstance().get_intClass_mw4y9a_k$())) {
      tmp = yield* $this$intercept.proceedWith_i5skhv_k$(new (HttpResponseContainer())(info, toInt(readText(yield* readRemaining(body, $completion)))), $completion);
    } else if (tmp0_subject.equals(getKClass(Source())) || tmp0_subject.equals(getKClass(Source()))) {
      tmp = yield* $this$intercept.proceedWith_i5skhv_k$(new (HttpResponseContainer())(info, yield* readRemaining(body, $completion)), $completion);
    } else if (tmp0_subject.equals(PrimitiveClasses_getInstance().get_byteArrayClass_57my8g_k$())) {
      var bytes = yield* toByteArray(body, $completion);
      checkContentLength(contentLength($this$intercept.context_1.get_response_xlk07e_k$()), fromInt(bytes.length), $this$intercept.context_1.get_request_jdwg4m_k$().get_method_gl8esq_k$());
      tmp = yield* $this$intercept.proceedWith_i5skhv_k$(new (HttpResponseContainer())(info, bytes), $completion);
    } else if (tmp0_subject.equals(getKClass(ByteReadChannel()))) {
      var responseJobHolder = Job(get_job(response.get_coroutineContext_115oqo_k$()));
      // Inline function 'kotlin.also' call
      var this_0 = writer($this$intercept, $this_defaultTransformers.coroutineContext_1, VOID, defaultTransformers$slambda$slambda(body, response));
      invokeOnCompletion(this_0, (it) => {
        responseJobHolder.complete_9ww6vb_k$();
        return Unit_instance;
      });
      attachWriterJob(body, this_0);
      var channel = this_0.channel_1;
      tmp = yield* $this$intercept.proceedWith_i5skhv_k$(new (HttpResponseContainer())(info, channel), $completion);
    } else if (tmp0_subject.equals(getKClass(HttpStatusCode()))) {
      cancel(body);
      tmp = yield* $this$intercept.proceedWith_i5skhv_k$(new (HttpResponseContainer())(info, response.get_status_jnf6d7_k$()), $completion);
    } else if (tmp0_subject.equals(getKClass(MultiPartData()))) {
      var tmp0 = $this$intercept.context_1.get_response_xlk07e_k$().get_headers_ef25jx_k$().get_6bo4tg_k$('Content-Type');
      var tmp$ret$2;
      $l$block: {
        // Inline function 'kotlin.checkNotNull' call
        if (tmp0 == null) {
          var message = 'No content type provided for multipart';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        } else {
          tmp$ret$2 = tmp0;
          break $l$block;
        }
      }
      var rawContentType = tmp$ret$2;
      var contentType = Companion_getInstance().parse_pc1q8p_k$(rawContentType);
      // Inline function 'kotlin.check' call
      if (!contentType.match_syvve3_k$(MultiPart_getInstance().FormData_1)) {
        var message_0 = 'Expected multipart/form-data, got ' + contentType.toString();
        throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message_0));
      }
      var tmp1_safe_receiver = $this$intercept.context_1.get_response_xlk07e_k$().get_headers_ef25jx_k$().get_6bo4tg_k$('Content-Length');
      var contentLength_0 = tmp1_safe_receiver == null ? null : toLong(tmp1_safe_receiver);
      var body_0 = new (CIOMultipartDataBase())($this$intercept.get_coroutineContext_115oqo_k$(), body, rawContentType, contentLength_0);
      var parsedResponse = new (HttpResponseContainer())(info, body_0);
      tmp = yield* $this$intercept.proceedWith_i5skhv_k$(parsedResponse, $completion);
    } else {
      tmp = null;
    }
    var result = tmp;
    var tmp_0;
    if (!(result == null)) {
      get_LOGGER().trace_fti9bv_k$('Transformed with default transformers response body ' + ('for ' + $this$intercept.context_1.get_request_jdwg4m_k$().get_url_18iuii_k$().toString() + ' to ' + toString(info.type_1)));
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  }), 2);
}
var properties_initialized_DefaultTransform_kt_ossax9;
function _init_properties_DefaultTransform_kt__20knxx() {
  if (!properties_initialized_DefaultTransform_kt_ossax9) {
    properties_initialized_DefaultTransform_kt_ossax9 = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.defaultTransformers');
  }
}
//region block: exports
export {
  defaultTransformers as defaultTransformers2r9wd7ftt31zw,
};
//endregion

//# sourceMappingURL=DefaultTransform.mjs.map
